// extracted by mini-css-extract-plugin
export var darkMode = "_redotech-arbiter-lib-theme-component-colors-dark-dark-mode";